export const LogoutHover = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M3 21V19H5V3.71597C5 3.23197 5.346 2.81797 5.821 2.73197L14.293 1.00997C14.619 0.949972 14.931 1.16697 14.99 1.49297C14.997 1.52797 15 1.56297 15 1.59997V2.999L18 3C18.552 3 19 3.448 19 4V19H21V21H17V5H15V21H3ZM13 9.88097H11V11.881H13V9.88097Z"
                fill="currentColor"
            />
        </svg>
    );
};